import { render, staticRenderFns } from "./ClientCapabilities.vue?vue&type=template&id=101580b2&scoped=true"
import script from "./ClientCapabilities.vue?vue&type=script&lang=js"
export * from "./ClientCapabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101580b2",
  null
  
)

export default component.exports